<script type="text/ecmascript-6">
import GeneralMixin from "JS/mixins/campaign/general";
import StringFilters from "JS/filters/stringFilters";
import { mapActions, mapGetters } from "vuex";
import { keys as _keys } from "lodash";

export default {
  name: "OptIn",
  filters: StringFilters,
  mixins: [GeneralMixin],
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    noLabel: {
      type: String,
      default: "No"
    },
    privacyPolicyDisclaimer: {
      default: "",
      type: String
    },
    shareLabels: {
      required: true,
      type: Object
    },
    socialShareEnabled: {
      type: Boolean,
      default: false
    },
    subscribeEmail: {
      required: true,
      type: Boolean
    },
    subscribeSms: {
      required: true,
      type: Boolean
    },
    subscribeEmailLabel: {
      required: true,
      type: String
    },
    subscribeSmsLabel: {
      required: true,
      type: String
    },
    subscriptionDefaultEmail: {
      required: true,
      type: Boolean
    },
    subscriptionDefaultSms: {
      required: true,
      type: Boolean
    },
    facebookShareEnabled: {
      required: true,
      type: Boolean
    },
    twitterShareEnabled: {
      required: true,
      type: Boolean
    },
    yesLabel: {
      type: String,
      default: "Yes"
    }
  },
  computed: {
    ...mapGetters({
      actionCompleted: "navigation/actionCompleted",
      completedOptions: "forms/completedOptions",
      formValues: "forms/formValues",
      cookieBadgeConvoVisible: "forms/cookieBadgeConvoVisible"
    }),
    optionSubscribeEmail: {
      get() {
        return this.formValues.subscribeEmail;
      },
      set(value) {
        this.setFormValue({ fieldName: "subscribeEmail", value });
      }
    },
    optionSubscribeSms: {
      get() {
        return this.formValues.subscribeSms;
      },
      set(value) {
        this.setFormValue({ fieldName: "subscribeSms", value });
      }
    },
    optionPostOnOwnWall: {
      get() {
        return this.formValues.postOnOwnWall;
      },
      set(value) {
        this.setFormValue({ fieldName: "postOnOwnWall", value });
      }
    },
    optionShareWithFollowers: {
      get() {
        return this.formValues.shareWithFollowers;
      },
      set(value) {
        this.setFormValue({ fieldName: "shareWithFollowers", value });
      }
    },
    isEmailStep() {
      return this.currentStep === "email";
    },
    isPhoneStep() {
      return this.currentStep === "phone" && !this.legislatorsPulled;
    },
    needAdditionalFields() {
      return this.$store.getters["forms/needAdditionalFields"][
        this.currentAction
      ];
    },
    showTwitterShareOptIn() {
      return (
        !this.needAdditionalFields &&
        this.currentAction === "twitter" &&
        this.socialShareEnabled &&
        this.twitterShareEnabled
      );
    },
    showSubscribeEmail() {
      return this.subscribeEmail && !this.completedOptions.subscribeEmail;
    },
    showSubscribeSms() {
      return this.subscribeSms && !this.completedOptions.subscribeSms;
    }
  },
  mounted() {
    this.eventsBus.$on("actionCompleted", this.updateCompletedOptions);
  },
  inject: {
    eventsBus: { from: "eventsBus" }
  },
  methods: {
    ...mapActions({
      setFormValue: "forms/formValues",
      setCompletedOption: "forms/completedOptions"
    }),
    kebabCaseHelper(string) {
      return this.$options.filters.kebabCase(string);
    },
    setOptionSubscribeEmail(value) {
      this.optionSubscribeEmail = value;
      this.eventsBus.$emit("skipStep", false);
    },
    setOptionSubscribeSms(value) {
      this.optionSubscribeSms = value;
      this.eventsBus.$emit("skipStep", false);
    },
    updateCompletedOptions() {
      _keys(this.completedOptions).forEach(option => {
        if (!this.completedOptions[option] && this.formValues[option]) {
          // mark newly completed options as complete
          this.setCompletedOption({ [option]: true });
        }
      });
    }
  }
};
</script>
